/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([
	'./LayoutBaseView'
],
function(BaseClass) {

	var PageCollectionView = null;
	PageCollectionView = BaseClass.extend( {

		init: function(options) {
			PageCollectionView.inherited('init', this, arguments);

			this._getViewId = this.consumeView._getViewId.bind(this.consumeView);

			this.htmlTemplate = options.services.getSvcSync('htmlTemplates');
		},

		destroy: function() {
			PageCollectionView.inherited('destroy', this, arguments);
		}

	});

	return PageCollectionView;
});
